<template>
  <div>
    <Table :columns="columns" :data="tableData">
      <template slot-scope="{ row }" slot="userName_staffNo">
        <div class="name-status">
          <div class="user-box">
            <i class="dian" :class="{ red: row.recommendWorkingState == 0, orange: row.recommendIsSus == 1 }"></i>
            <span class="user-name">{{ row.recommendStaffNo }}</span>
            <span v-if="row.recommendStaffNo">/</span>
            <span class="user-name">{{ row.recommend }}</span>
          </div>
        </div>
      </template>
    </Table>
    <Page :total="total" :current.sync="pageNum" :page-size="pageSize" show-total @on-change="getList" style="text-align: center; margin-top: 20px" />
  </div>
</template>

<script>
import filter from '@/api/filter';
import { common, pageTool } from '@/api/mixins';
export default {
  props: ['actId'],
  mixins: [common, pageTool],
  data() {
    return {
      columns: [
        {
          title: '保单号',
          align: 'center',
          key: 'policyNo',
          minWidth: 180,
          fixed: 'left'
        },
        {
          title: '批单号',
          width: '160',
          key: 'billNo',
          align: 'center',
          render(h, params) {
            return <span>{params.row.billNo ? params.row.billNo : '-'}</span>;
          }
        },
        {
          title: '关联活动',
          align: 'center',
          key: 'activityName',
          minWidth: 250
        },
        {
          title: '保险公司',
          align: 'center',
          key: 'companyName',
          minWidth: 160
        },
        {
          title: '保险产品',
          align: 'center',
          key: 'productName',
          minWidth: 280
        },
        {
          title: '险种名称',
          align: 'center',
          key: 'insuranceName',
          minWidth: 300
        },
        {
          title: '最新状态',
          align: 'center',
          minWidth: 120,
          render(h, params) {
            const policyStatus = params.row.policyStatus;
            if (policyStatus == 1) {
              return <span>已承保</span>;
            } else if (policyStatus == -1) {
              return <span>已退保</span>;
            } else if (policyStatus == 0) {
              return <span>已终止</span>;
            } else if (policyStatus == 2) {
              return <span>已中止</span>;
            }
          }
        },
        {
          title: '承保日期',
          align: 'center',
          key: 'insureTime',
          minWidth: 130,
          render(h, params) {
            let insureTime = params.row.insureTime;
            return <span>{filter.filterTime(insureTime, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '生效日期',
          align: 'center',
          key: 'effectTime',
          minWidth: 130,
          render(h, params) {
            let effectTime = params.row.effectTime;
            return <span>{filter.filterTime(effectTime, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '回执回销日期',
          align: 'center',
          key: 'receiptDate',
          minWidth: 130,
          render(h, params) {
            let receiptDate = params.row.receiptDate;
            return <span>{filter.filterTime(receiptDate, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '回访日期',
          align: 'center',
          key: 'revisitDate',
          minWidth: 130,
          render(h, params) {
            let revisitDate = params.row.revisitDate;
            return <span>{filter.filterTime(revisitDate, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '犹豫止期',
          align: 'center',
          key: 'hesitateDate',
          minWidth: 130,
          render(h, params) {
            let hesitateDate = params.row.hesitateDate;
            return <span>{hesitateDate ? filter.filterTime(hesitateDate, 'YYYY-MM-DD') : '-'}</span>;
          }
        },
        {
          title: '保障期',
          align: 'center',
          key: 'guaranteeDesc',
          minWidth: 120
        },
        {
          title: '交费期',
          align: 'center',
          key: 'payDesc',
          minWidth: 120
        },
        {
          title: '保单年度',
          align: 'center',
          key: 'commissionIndex',
          minWidth: 100,
          render(h, params) {
            return <span>1</span>;
          }
        },
        {
          title: '交费期次',
          align: 'center',
          minWidth: 130,
          render(h, params) {
            return <span>1</span>;
          }
        },
        {
          title: '实收保费',
          align: 'center',
          key: 'fee',
          minWidth: 100
        },
        {
          title: '标准保费',
          key: 'foldFyb',
          align: 'center',
          width: '100'
        },
        {
          title: '奖励归属',
          align: 'center',
          key: 'recommend',
          minWidth: 120,
          slot: 'userName_staffNo'
        },
        {
          title: '计算因子',
          align: 'center',
          key: 'calFactor',
          minWidth: 130,
          render(h, params) {
            if (params.row.calFactor == 1) {
              return <span>被推荐人标保</span>;
            } else if (params.row.calFactor == 3) {
              return <span>被推荐人费用</span>;
            } else if (params.row.calFactor == 2) {
              return <span>被推荐人规保</span>;
            } else {
              return <span>-</span>;
            }
          }
        },
        {
          title: '奖励费率',
          align: 'center',
          key: 'actCommission',
          minWidth: 100,
          render(h, params) {
            return <span>{params.row.actCommission || 0}%</span>;
          }
        },
        {
          title: '奖励',
          align: 'center',
          key: 'activityIncome',
          minWidth: 100
        },
        {
          title: '基础费用归属',
          align: 'center',
          key: 'salesmanName',
          minWidth: 150
        },
        {
          title: '推荐人团队',
          align: 'center',
          key: 'recommendGroup',
          minWidth: 120
        },
        {
          title: '推荐人机构',
          align: 'center',
          key: 'recommendOrg',
          minWidth: 120
        }
      ],
      tableData: []
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      let data = {
        reportId: this.$route.query.reportId,
        type: 10,
        activityId: this.actId,
        userId: this.$route.query.userId,
        pageSize: this.pageSize,
        pageNo: this.pageNum
      };
      this.$http({
        url: '/buz/userSalaryDetails/getDetail',
        type: 'POST',
        data
      }).then(res => {
        this.tableData = res.data;
        this.total = res.total;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.name-status {
  align-items: center;
  /deep/ .user-box {
    font-size: 12px;
    .dian {
      display: inline-block;
      flex-shrink: 0;
      width: 5px;
      height: 5px;
      background: #35bf3f;
      border-radius: 50%;
      margin-right: 4px;
      &.red {
        background: #e3461f;
      }
      &.orange {
        background: #ff9900 !important;
      }
    }
    &.text {
      color: #515c6f;
    }
    .user-name {
      font-size: 13px;
      &.dashed {
        border-bottom: 1px dashed #236dff;
      }
      &.line {
        border-bottom: 1px solid #236dff;
      }
    }
    i {
      color: #bababa;
      font-size: 13px;
    }
    .iconduichang {
      margin-left: 4px;
    }
    &.no-token {
      color: #515c6f;
      .user-name {
        cursor: auto;
      }
    }
  }
}
</style>
